import axios from "axios";
import jwtDecode from "jwt-decode";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// https://symfony.com/doc/current/security/impersonating_user.html
instance.defaults.params = {};
instance.interceptors.request.use(function (config) {
  let switchUser = window.localStorage.getItem("switchUser");
  if (switchUser !== null) {
    switchUser = JSON.parse(switchUser);
    config.params["_switch_user"] = switchUser.email;
  }
  return config;
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/login")
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return instance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refresh_token = window.localStorage.getItem("refreshToken");
      return new Promise(function (resolve, reject) {
        const refreshInstance = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });

        refreshInstance
          .post("/api/refresh_token", { refresh_token })
          .then(({ data }) => {
            const { exp: expiration } = jwtDecode(data.token);
            console.info(
              "Expiration du token : " + new Date(expiration * 1000)
            );

            window.localStorage.setItem("authToken", data.token);
            window.localStorage.setItem("refreshToken", data.refresh_token);

            instance.defaults.headers["Authorization"] = "Bearer " + data.token;
            instance.defaults.headers.common["Authorization"] =
              "Bearer " + data.token;
            processQueue(null, data.token);

            originalRequest.headers["Authorization"] = "Bearer " + data.token;
            resolve(instance(originalRequest));
          })
          .catch((err) => {
            console.log("err", err);
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
